export default "__VITE_ASSET__a3d7af6b__"